import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accordion-footer',
  templateUrl: './accordion-footer.component.html',
  styleUrls: ['./accordion-footer.component.scss']
})
export class AccordionFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
